export const en = {
    title: 'You currently do not have access to the service',
    description: "Contact your company's coordinator",
};
